export interface ItemAction {
  id: string;
  label: string;
  onClick: () => void | Promise<void>;
  visible: boolean;
}

export function getVisibleActions(actions: ItemAction[]) {
  return actions
    .filter((action) => action.visible)
    .map(({ id, label, onClick }) => ({ id, label, onClick }));
}
